import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';

import { useParams, useNavigate } from "react-router-dom";

import { SimsoAction } from 'src/actions/simso.action';

import numeral from 'numeral';

import { Helmet } from "react-helmet";

import {
    CONFIRM_TYPES,
    DEFAULT_ROW_PER_PAGE,
    DEFAULT_HOMEPAGE_ROW_PER_PAGE,
    ROW_PER_PAGE_OPTIONS,
    SIM_TYPE_LIST,
    SIM_TYPE_LIST_OBJ,
} from 'src/utils/constants';

import iconMobifone from "../../assets/images/icon_mobifone.png";
import iconVinaphone from "../../assets/images/icon_vinaphone.png";
import iconViettel from "../../assets/images/icon_viettel.png";
import logoNhaMang from "../../assets/images/logo_mang.svg";

const TheHomepageYnghiasimDetail = ({ product }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { so_can_tra } = useParams();
    const [ynghiasimContent, setYnghiasimContent] = useState("");
    const [isLoading1, setIsLoading] = useState("0");

    const [formData, setFormData] = useState({
        number: ""
    });

    useEffect(() => {
        setFormData({ ...formData, number: so_can_tra && so_can_tra.toString().trim() != '' ? ' ' + so_can_tra.toString().trim() : '' });
        onPressPositive();
    }, [so_can_tra])

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleKeyDown = event => {
        if (event.key === 'Enter') {
            onPressPositive();
        }
    };

    const onPressPositive = async () => {
        try {
            setYnghiasimContent("");
            setIsLoading("1");

            if (so_can_tra && so_can_tra.toString().trim() != '' ? ' ' + so_can_tra.toString().trim() : '') {

                let number = so_can_tra.toString().trim();

                const response = await dispatch(SimsoAction.getSimAnalysis(number))
                console.log(response);

                setYnghiasimContent(response.content);
                setIsLoading("0");
            }
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <>
            <Helmet>
                <title>Ý nghĩa sim{so_can_tra && so_can_tra.toString().trim() != '' ? ' ' + so_can_tra.toString().trim() : ''} | Kho số - Di Dong Telecom</title>
            </Helmet>

            <div style={{ margin: "0 0", padding: "20px", borderRadius: "10px", boxShadow: "0px 4px 10px rgba(0,0,0,0.2)", background: "var(--background-color)", textAlign: 'center' }}>
                <div>
                    <input type="text" placeholder='Nhập số cần phân tích' name="number" value={formData.number} onChange={handleChange} onKeyDown={handleKeyDown} required style={{ width: "200px", margin: 'auto', padding: "10px", border: "1px solid #ddd", borderRadius: "5px", fontSize: 16, textAlign: 'center' }} />
                </div>
                <button onClick={() => {
                        let number = formData.number.toString().trim();

                        if (number == "") {
                            alert("Bạn chưa nhập số nào để phân tích!");
                            setIsLoading("0");
                            return;
                        }

                        navigate(`/trang-chu/y-nghia-sim/${number}`)
                    }} style={{ width: "200px", margin: '10px auto', padding: "10px", background: "var(--main-color)", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", fontSize: "16px", fontWeight: "bold", transition: "0.3s" }}
                    onMouseEnter={(e) => e.target.style.background = "var(--main-color)"}
                    onMouseLeave={(e) => e.target.style.background = "var(--main-color)"}>
                    DỊCH NGHĨA SIM
                </button>
            </div>
            {!ynghiasimContent && so_can_tra && isLoading1 === "1" && <div style={{ margin: "10px 0", padding: "20px", borderRadius: "10px", boxShadow: "0px 4px 10px rgba(0,0,0,0.2)", background: "var(--background-color)" }}>
                Đang giải số...
            </div>}
            {ynghiasimContent && so_can_tra && <div style={{ margin: "10px 0", padding: "20px", borderRadius: "10px", boxShadow: "0px 4px 10px rgba(0,0,0,0.2)", background: "var(--background-color)" }}>
                <div className='ynghiasim-content' dangerouslySetInnerHTML={{ __html: ynghiasimContent }} />
            </div>}
        </>
    );
};

export default TheHomepageYnghiasimDetail;